module.exports = __webpack_public_path__ + "static/media/espace_students.1d5e2d88.png";